/*
 * Shapes every route shares: the error answer and list paging (?cursor=&limit=, 50 by default, 200 at most).
 */
import { z } from "zod";

/** Every error answer: a stable code for programs and plain words for people. */
export const errorBody = z.object({ code: z.string(), message: z.string() });
export type ErrorBody = z.infer<typeof errorBody>;

export const listQuery = z.object({
  cursor: z.string().max(200).optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
});
export type ListQuery = z.infer<typeof listQuery>;

/** A phone number as typed ("(504) 555-0149"), checked and stored the one way everything compares it (+15045550149). */
export const phoneSchema = z
  .string()
  .trim()
  .transform((s) => s.replace(/[^\d+]/g, ""))
  .pipe(z.string().regex(/^\+?\d{10,15}$/, "Type the full phone number, with the area code."))
  .transform(normalizePhone);

/** A US number to +1XXXXXXXXXX; numbers that already start with + are kept. */
export function normalizePhone(raw: string): string {
  const digits = raw.replace(/[^\d+]/g, "");
  if (digits.startsWith("+")) return digits;
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return `+${digits}`;
}
